/* Emri i vetures ashtu si e thote njeriu.
   Problemi: modeli "Golf" plus etiketa "Golf 7 (2012–2017)" jepte "Golf Golf 7".
   Rregulli: nese etiketa e ka tashme brenda emrin e modelit, mos e perserit modelin. */
(function () {
  window.BaciLabel = function (model, label) {
    var m = (model || '').toLowerCase();
    var l = (label || '').toLowerCase();
    if (!m) return label || '';
    if (!l) return model;
    if (l.indexOf(m) === 0 || l.indexOf(' ' + m + ' ') > -1) return label;
    return model + ' ' + label;
  };
})();
